import React from "react"
import { Link } from "gatsby"
import "../components/index.css"
import Button from "./buttons"
import SlidShowText from "./slideshowtxt"
//import IMG_TRAIN from "../components/imgTrain.js"
//import IMG_FELSEN from "../components/imgAlle.js"
//import IMG_ATOM from "../components/imgAtomkraft.js"


const linkStyle = {
  color: `black`,
  textDecoration: `none`,
}
const activeLinkStyle = {
  color: `black`,
  fontWeight: 700,
  textDecoration: 'none',
  borderBottom: '5px solid black',
}

class mainPage extends React.Component {

  render()
  {

  return (
    <div>
      <div style={{paddingBottom: '50px',
        margin: '0px 0px 0px 0px',
        width: '50%',
        border: '0px solid black',
        borderCollapse: 'collapse'}}>
        <SlidShowText/>
      </div>
      {/* <div style={{paddingBottom: '50px',
        margin: '0px 0px 0px 0px',
        width: '80%',
        border: '0px solid black',
        borderCollapse: 'collapse'}}>
      <h1>Neue Artikel</h1>
      <table>
        <tr>
          <td>
            <div style={{width: '30%', margin: '0 auto', zIndex: '0'}}>
                <IMG_FELSEN/>
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <div style={{margin: '0 auto', zIndex: '0'}}>
              <Link to="/article_1" style={linkStyle} activeStyle={activeLinkStyle}>Alle wollen Klimaschutz. Warum passiert nichts?</Link>
            </div>
          </td>
        </tr>
      </table>
      <p/>
      </div> */}
      <h1>Der Klimaschutz kommt nicht voran!</h1>
      <h1>Sagen sie uns was Sie wissen</h1>
      <Button buttonname='MISSSTAND MELDEN' buttoncolor='red' buttonwidth='75%' link='testenv'/>

      <div style={{paddingBottom: '50px',
        margin: '0px 0px 0px 0px',
        width: '80%',
        border: '0px solid black',
        borderCollapse: 'collapse'}}>
        <p>Die schnelle und vollständige Energiewende ist der einzige Weg, um die katastrophalen Folgen des Klimawandels und die zerstörerische Ausbeutung von Ressourcen noch zu begrenzen.</p>
        <p>Die erforderlichen Prozesse sind jedoch ausgesprochen komplex und können nur Ressortübergreifend gelöst werden. Politiker, Behörden, Unternehmen und Verbraucher sind damit offensichtlich häufig überfordert.
          Entscheidungen werden aufgrund von Partikularinteressen getroffen und ganzheitliches Abwägen bleibt aus, in Genehmigungsbehörden wird einseitig priorisiert, Verantwortungsübernahme vermieden und wegen Überlastung blockiert. Den zur Rechtfertigung angeführten „Sachargumenten“ wird von Politikern und Vorgesetzten nichts entgegen gesetzt, weil die Sachkenntnis fehlt, die Kompetenz der eigenen Fachbehörde nicht in Frage gestellt werden kann oder Konflikte gescheut werden.</p>
        <p>Das wollen wir gemeinsam mit Ihnen ändern! Um als Bürger und Bürgerinnen und Akteure diesen Hürden nicht weiter ohnmächtig gegenüber zu stehen, können Sie an KlimaLeaks Erfahrungsberichte und Dokumente übermitteln, auch anonym und ungefiltert!.</p>
        <ul>
          <li>Experten aus allen Fachbereichen werten diese Eingaben aus,</li>
          <li>bitten ggfs. die Verantwortlichen über direkte Ansprache zu einer Stellungnahme</li>
          <li>bewerten die Standpunkte</li>
          <li>und konfrontieren die Verantwortlichen über direkte Ansprache und Aktionen zum Sachverhalt.</li>
        </ul>
        <p>Damit werden den Klima-Aktivisten auf Erfahrungswissen basierende Ansatzpunkte zur Durchsetzung der Klimaziele zur Kenntnis gebracht, so dass statt allgemeiner Forderungen konkrete Handlungsoptionen resultieren können.</p>

        <div style={{padding: '0 0% 0 0', width: '75%', color: 'red'}}>
          <Button buttonname='MISSSTAND MELDEN' buttoncolor='red' buttonwidth='100%' link='testenv'/>
        </div>

        <div style={{padding: '20px 0% 0 0', width: '75%', color: 'blue'}}>
          <Button buttonname='MITGLIEDSCHAFT BEANTRAGEN' buttoncolor='#229922' buttonwidth='100%' link='https://api.campai.com/application/5e0b758b1b60a3002df60c77'/>
        </div>
        {/*  
         <Leaks/>
         */}
      </div>
    </div>
  )
 }
}

export default mainPage
